/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 10/3/2022
 */

export const CompletionStatus = Object.freeze({
	NOT_SET: "NOT_SET",
	NOT_APPLICABLE: "NOT_APPLICABLE",
	ASSIGNED: "ASSIGNED",
	WAITING_FOR_SIGNATURE: "WAITING_FOR_SIGNATURE",
	COMPLETED: "COMPLETED",
	WAITING_OTHER: "WAITING_OTHER",
	REQUIRES_FOLLOWUP: "REQUIRES_FOLLOWUP",
	NEEDS_RETAKE_SAFETY_CARE: "NEEDS_RETAKE_SAFETY_CARE",
})
